import type { SdsConsumerSchema } from './types'

export type SdsConsumerAsyncJobState = SdsConsumerSchema<'SdsConsumerAsyncJobState'>
export type SdsConsumerAsyncJobStatus = SdsConsumerAsyncJobState['status']

export type SdsConsumerAsyncJobAcceptedResponse = SdsConsumerSchema<'SdsConsumerAsyncJobAcceptedResponse'>

export type SdsConsumerAsyncJobStatusResponse = SdsConsumerSchema<'SdsConsumerAsyncJobStatusResponse'>

export type SdsConsumerAsyncJobConflictResponse = SdsConsumerSchema<'SdsConsumerAsyncJobConflictResponse'>

export type SdsConsumerAsyncJobStartResponse = SdsConsumerAsyncJobAcceptedResponse | SdsConsumerAsyncJobConflictResponse

export function getSdsConsumerAsyncJobKey(
  job: Pick<SdsConsumerAsyncJobState, 'kind' | 'traceId' | 'startedAt'>
): string {
  return [job.kind, job.traceId ?? job.startedAt ?? 'none'].join(':')
}

export function isSdsConsumerAsyncJobRunning(
  job: Pick<SdsConsumerAsyncJobState, 'status'> | null | undefined
): boolean {
  return job?.status === 'running'
}
